import { Usage } from '../api/types/payment';

/** ボトムシート展開用のクエリパラメータを生成（契約一覧画面で使用） */
export const useGenBottomSheetQueryParams = () => {
  const genBottomSheetQueryParams = (path: string, paymentUsage: Usage) => {
    return `${path}?isPaymentBottomSheetActive=true&paymentUsage=${paymentUsage}&applicationId=:applicationId`;
  };
  return { genBottomSheetQueryParams };
};
